export default "__VITE_ASSET__BAD5tR_m__"